import { useQuery } from '@tanstack/react-query';

import { getFileUrl } from '../utils/axios';
import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  noRetry?: boolean;
  enabled?: boolean;
}

export function useProjectContextImg({ projectId, noRetry = false, enabled = true }: Params) {
  const url = `/projects/${projectId}/context-img`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<string>({
    queryKey: queryKeys.getProjectContextImg(projectId),
    queryFn: () => getFileUrl({ url }),
    enabled: !!projectId && enabled,
    retry: !noRetry,
  });

  return {
    imgUrl: data,
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
